import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Dialog } from '@material-ui/core';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { AgentSchedulerProvider } from 'Context/NewAgentSchedulerContext';
import ViewContainer from './ViewContainer';
import SchedulerModalHeader from './SchedulerModalHeader';

const styles = theme => ({
  root: {},
  title: {
    display: 'flex',
    padding: 0,
    backgroundColor: theme.palette.facet.primaryBlueMuted,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  closeButton: {
    color: theme.palette.common.white,
    fontSize: 34,
  },
  titleText: {
    color: theme.palette.common.white,
    fontSize: 32,
  },
  legendContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(7, 0),
    '& > div:not(:first-child)': {
      marginLeft: theme.spacing(5),
    },
  },
  legendEntry: {
    ...theme.typography.body1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.palette.facet.primaryGray,
  },
  legendBubble: {
    width: 19,
    height: 19,
    borderRadius: '50%',
    marginRight: theme.spacing(1),
  },
  greenBubble: {
    backgroundColor: theme.palette.facet.accentGreen2,
  },
  blueBubble: {
    backgroundColor: theme.palette.facet.accentBlue11,
  },
  redBubble: {
    backgroundColor: theme.palette.facet.red,
  },
});

const MCSchedulerModal = ({
  className,
  classes,
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'MC Scheduler',
    isPageView: true,
  });

  return (
    <AgentSchedulerProvider>
      <Dialog
        {...rootNodeProps}
        test="scheduler-modal"
        open
        fullScreen
        className={classNames(className, classes.root)}
      >
        <SchedulerModalHeader />
        <ViewContainer />
      </Dialog>
    </AgentSchedulerProvider>
  );
};

MCSchedulerModal.defaultProps = {
  className: '',
};

MCSchedulerModal.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MCSchedulerModal);
